import { Component, Inject, OnInit } from "@angular/core";
import {
  FormArray,
  FormGroup,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MasterService } from "../../pages/master/master.service";
import { PurchaseOrderService } from "../../pages/purchase-order/purchase-order-service";
import { duppaymentTerms } from "src/app/theme/utils/app-validators";
import { MatSnackBar } from "@angular/material/snack-bar";

// WO Type -> allowed Milestone values (billing milestones)
// const MILESTONE_MAP: { [key: string]: string[] } = {
//   'Supply': ['Advance', 'Material Dispatch', 'Material Delivery', 'Retention'],
//   'Labour': ['Advance', 'Running Bill (RA)', 'Work Completion', 'Retention'],
//   'SITC': ['Advance', 'Supply', 'Installation', 'Testing & Commissioning', 'Retention'],
//   'Turnkey/EPC': ['Advance', 'Engineering Approval', 'Procurement', 'Supply', 'Installation', 'Testing & Commissioning', 'Project Handover', 'Retention'],
//   'AMC': ['Advance', 'Monthly Billing', 'Quarterly Billing', 'Half-Yearly Billing', 'Annual Billing'],
//   'Service Contract': ['Advance', 'Service Completion', 'Monthly Service Bill', 'Final Settlement'],
// };

@Component({
  selector: "app-payment-terms",
  templateUrl: "./payment-terms.component.html",
  styleUrls: ["./payment-terms.component.scss"],
})
export class PaymentTermsComponent implements OnInit {
  public paymentTermsForm: UntypedFormGroup;

  // "Days" intentionally excluded from the visible columns per requirement (3)
  public paymentTermsColumns = ["%", "Milestone", "Terms Description", "Action"];

  paymentTermsList: any[] = [];
  viewType: any;
  editType: any;
  percentageError: boolean = true;

  woType: any  = null;
 // milestones: string[] = [];

 allBillingMilestones: any[] = [];
milestones: { key: number; label: string }[] = [];
milestonesLoading: boolean = false;

  showMilestone: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<PaymentTermsComponent>,
    public fb: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data,
    private masterService: MasterService,
    private poService: PurchaseOrderService,
    private _snackBar: MatSnackBar
  ) {
    dialogRef.disableClose = true;
    this.getAllPaymentTerms();
    this.buildForm();
  }

  buildForm() {
    this.paymentTermsForm = this.fb.group({
      paymentTermsDetails: this.fb.array([]),
    });

    this.viewType = this.data?.viewType;
    this.editType = this.data?.editType;

    // Milestone column: opt-in per caller
    this.showMilestone = !!this.data?.showMilestone;

    // Adjust the visible header columns based on whether Milestone is shown
    this.paymentTermsColumns = this.showMilestone
      ? ["%", "Milestone", "Terms Description", "Action"]
      : ["%", "Terms Description", "Action"];

    // WO Type drives which Milestone options are available (5)
    // this.woType = this.data?.woType || null;
    // this.milestones = MILESTONE_MAP[this.woType] || [];

    this.woType = this.data?.woType || null;
     this.milestones = [];

    if (this.data?.data && this.data.data.length) {
      this.data.data.forEach((item: any) => this.onNewItemAdded1(item));
    } else {
      this.onNewItemAdded();
    }

    if (this.viewType === "VIEW" || this.viewType === "Tax_Convert") {
      this.paymentTermsForm.disable();
    }

    this.checkTotalPercentage();

    if (this.showMilestone && this.woType?.woTypeKey) {
  this.loadBillingMilestones();
}

  }

  get paymentTermsDetails() {
    return (this.paymentTermsForm.get("paymentTermsDetails") as FormArray)
      .controls;
  }

  // Blank row — validates the current last row before allowing a new one
  onNewItemAdded = () => {
    const formArray = this.paymentTermsForm.get(
      "paymentTermsDetails"
    ) as FormArray;

    if (formArray.length > 0) {
      const lastRow = formArray.at(formArray.length - 1) as FormGroup;
      lastRow.markAllAsTouched();
      lastRow.updateValueAndValidity();
      if (lastRow.invalid) {
        this._snackBar.open(
          "Please fix validation errors in the current row before adding a new one.",
          null,
          { duration: 3000, verticalPosition: "top", panelClass: ["if-error"] }
        );
        return;
      }
    }

    formArray.push(
      this.fb.group({
        paymentPerc: [0, [Validators.required, Validators.min(1), Validators.max(100)]],
        milestone: [null, this.showMilestone ? [Validators.required] : []],
        paymentTermKey: [
          null,
          Validators.compose([Validators.required, duppaymentTerms(formArray)]),
        ],
        days: [null, []], // kept in the model, hidden from UI (3)
      })
    );
  };

  // Row from saved data (edit/view) — no gate-check needed
  onNewItemAdded1 = (data?) => {
    const formArray = this.paymentTermsForm.get(
      "paymentTermsDetails"
    ) as FormArray;

    if (data?.milestone) {
      this.ensureMilestoneOption(data.milestone);
    }

    formArray.push(
      this.fb.group({
        paymentPerc: [
          data?.paymentPerc || 0,
          [Validators.required, Validators.min(1), Validators.max(100)],
        ],
        milestone: [
          data?.milestone || null,
          this.showMilestone ? [Validators.required] : [],
        ],
        paymentTermKey: [
          data?.paymentTermKey || null,
          Validators.compose([Validators.required, duppaymentTerms(formArray)]),
        ],
        days: [data?.days || null, []],
      })
    );
  };

  // If a row's saved milestone isn't in the current WO Type's list
  // (e.g. WO Type changed after this row was saved), keep it selectable
  // so existing data still renders correctly instead of showing blank.
  // private ensureMilestoneOption(value: string) {
  //   if (value && !this.milestones.includes(value)) {
  //     this.milestones = [...this.milestones, value];
  //   }
  // }

  onDeleteItem(index: number) {
    (this.paymentTermsForm.get("paymentTermsDetails") as FormArray).removeAt(
      index
    );
    this.checkTotalPercentage(index);
  }

  ngOnInit(): void {}

  getAllPaymentTerms() {
    this.masterService.getAllPaymentTerms().subscribe((res) => {
      this.paymentTermsList = res;
    });
  }

  close(): void {
    this.dialogRef.close();
  }

  onSave() {
    this.dialogRef.close(
      this.paymentTermsForm.get("paymentTermsDetails").getRawValue()
    );
  }

  checkTotalPercentage(index?: any): void {
    const paymentTermsDetails = this.paymentTermsForm.get(
      "paymentTermsDetails"
    ).value;
    let totalPercentage = 0;
    paymentTermsDetails.forEach((term: any) => {
      totalPercentage += term.paymentPerc;
      this.percentageError = true;
      if (totalPercentage == 100) {
        this.percentageError = false;
      }
    });
    if (totalPercentage > 100) {
      (this.paymentTermsForm.get("paymentTermsDetails") as FormArray).controls[
        index
      ]
        .get("paymentPerc")
        .setValue(0);
      this.percentageError = true;
    }
  }

  loadBillingMilestones() {
  this.milestonesLoading = true;
  this.masterService.getAllBillingMilestones(0, 7).subscribe({
    next: (res: any) => {
      this.allBillingMilestones = res?.data || [];
      this.applyMilestoneFilter();
      this.milestonesLoading = false;
    },
    error: (err) => {
      console.error('Error loading billing milestones', err);
      this.milestonesLoading = false;
    }
  });
}

private applyMilestoneFilter() {
  this.milestones = this.allBillingMilestones
    .filter(m => m.woType?.woTypeKey === this.woType?.woTypeKey && m.status === 'ACTIVE')
    .map(m => ({ key: m.billingMilestoneKey, label: m.milestoneDescription }));

  this.paymentTermsDetails.forEach((row) => {
    const val = row.get('milestone')?.value;
    if (val != null) this.ensureMilestoneOption(val);
  });
}

private ensureMilestoneOption(key: any) {
  if (this.milestones.some(m => m.key === key)) return;
  const found = this.allBillingMilestones.find(m => m.billingMilestoneKey === key);
  if (found) {
    this.milestones = [...this.milestones, { key: found.billingMilestoneKey, label: found.milestoneDescription }];
  }
}


}